import { useState, useEffect, useRef } from 'react';

/**
 * 用于检测文本是否超出当前DOM元素
 * 1. 多行文本直接使用clientHeight 对比 scrollHeight获得结果
 * 2. 单行文本通过提取文本内容构造DOM，然后检测构造出来的DOM元素实际宽度，
 *    对比当前node的实际宽度判断文本是否超过
 *
 * @param rows 行数，比如设为2，则超过2行返回true
 * @param text 文本，用于重新计算
 */
const useTextOverflow = (rows: number, text: string) => {
  const [isOverflow, setIsOverflow] = useState(false);
  const domRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (domRef.current) {
      const { scrollHeight, clientHeight, scrollWidth, clientWidth } = domRef.current;
      // 多行文本
      if (rows > 1) {
        setIsOverflow(scrollHeight > clientHeight);
      } else {
        // 如果单行省略通过src/styles/mixin.less single-line()实现，则通过scrollWidth > clientWidth判定
        // 如果是通过n-line()实现，则通过scrollHeight > clientHeight判定
        setIsOverflow(scrollWidth > clientWidth || scrollHeight > clientHeight);
      }
    }
  }, [rows, text]);

  return { domRef, isOverflow };
};

export default useTextOverflow;
